export default [
    {
        header: 'Component(Sidebar):products',
        action: 'visit',
        resource: 'product-new',
    },
    {
        title: 'Component(Sidebar):products-new-product',
        icon: 'BoxIcon',
        activeForRoutes: ['product-new'],
        route: 'product-new-wizard',
        action: 'visit',
        resource: 'product-new-wizard',
    },
    {
        title: 'Component(Sidebar):products-overview',
        icon: 'LayersIcon',
        route: 'product-overview',
        activeForRoutes: ['product-scip-notification', 'product-card'],
        action: 'visit',
        resource: 'product-overview',
    },
    {
        title: 'Component(Sidebar):submission-overview',
        icon: 'UploadCloudIcon',
        route: 'submission-overview',
        activeForRoutes: ['submission-card'],
        action: 'visit',
        resource: 'submission-overview',
    },
]
